"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconWorkFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 19",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M20,4 L14,4 L14,2 C14,0.9 13.1,0 12,0 L8,0 C6.9,0 6,0.9 6,2 L6,4 L0,4 L0,19 L20,19 L20,4 Z M12,4 L8,4 L8,2 L12,2 L12,4 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconWorkFilled')(IconWorkFilled);